import { render, staticRenderFns } from "./StopContract.vue?vue&type=template&id=23501dba&scoped=true"
import script from "./StopContract.vue?vue&type=script&lang=js"
export * from "./StopContract.vue?vue&type=script&lang=js"
import style0 from "./StopContract.vue?vue&type=style&index=0&id=23501dba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23501dba",
  null
  
)

export default component.exports